import * as React from 'react';
import { useCallback } from 'react';
import { withRipple } from '../../hocs/withRipple/index.js';
import { StyledSonntagIcon, IconWrapper, StyledButton, TruncationWrapper, RippleContainer } from './styled.js';

/**
 * @deprecated Use DefaultButton instead
 */
const SonntagButton = ({ className, size, outlined = false, fullWidth = false, iconPath, iconSvgCode, children, disabled = false, accentColor, iconColor, solid = false, onClick = () => { }, ...props }) => {
    const RippleEffect = withRipple(RippleContainer);
    const renderIcon = useCallback(() => {
        if (!iconPath && !iconSvgCode) {
            return null;
        }
        if (iconPath && !iconSvgCode) {
            return (React.createElement(StyledSonntagIcon, { iconPath: iconPath, color: iconColor || (!solid && accentColor) || '', onlyIcon: !children }));
        }
        if (iconSvgCode && !iconPath) {
            const SvgIcon = iconSvgCode;
            return (React.createElement(IconWrapper, { color: iconColor || (!solid && accentColor) || '', onlyIcon: !children },
                React.createElement(SvgIcon, { viewBox: "0 0 1000 1000" })));
        }
        return null;
    }, [iconPath, iconSvgCode, iconColor, solid, accentColor, children]);
    return (React.createElement(StyledButton, { className: className, size: size, outlined: outlined, fullWidth: fullWidth, disabled: disabled, accentColor: accentColor, solid: solid, withIcon: (iconPath || iconSvgCode) && true, onlyIcon: !children, onClick: onClick, ...props },
        renderIcon(),
        React.createElement(TruncationWrapper, null, children),
        !disabled && React.createElement(RippleEffect, null)));
};

export { SonntagButton };
